import { FinanceRate } from '@kanda-libs/ks-frontend-services';
import { formatToPercentage, GroupedByAprAndType } from 'utils';

export const sortFinanceRateKeys = (grouped: GroupedByAprAndType): string[] =>
  Object.keys(grouped).sort((name1: string, name2: string) => {
    const [rawApr1, type1] = name1.split('-');
    const [rawApr2, type2] = name2.split('-');
    if (type1 === type2) {
      const apr1 = parseInt(rawApr1, 10);
      const apr2 = parseInt(rawApr2, 10);
      return apr1 - apr2;
    }
    if (type1 === 'INTEREST_FREE') return -1;
    if (type2 === 'INTEREST_FREE') return 1;
    if (type1 === 'BUYNOW_PAYLATER') return 1;
    if (type2 === 'BUYNOW_PAYLATER') return -1;
    return 0;
  });

export const formatNameToAprLabel = (name: string): string => {
  const [rawApr, type] = name.split('-');
  const apr = parseInt(rawApr, 10);
  const pct = formatToPercentage(apr);
  if (type === 'BUYNOW_PAYLATER') return `${pct} BNPL`;
  return `${pct} APR`;
};

export const formatTermsFromRates = (rates: FinanceRate[]): string => {
  if (rates.length === 1) {
    const { duration } = rates[0];
    if (!duration) return '--';
    if (duration % 12 !== 0) return `${duration} months`;
    if (duration === 12) return '1 year';
    return `${duration / 12} years`;
  }
  const allTerms = rates
    .map((rate) => rate.duration)
    .filter((num) => typeof num === 'number')
    .filter((num, idx, arr) => arr.indexOf(num) === idx)
    .sort((t1, t2) => t1 - t2);
  const terms = [allTerms[0], allTerms.slice(-1)[0]];
  const month = terms.some((t) => t % 12 !== 0);
  if (month) return `${terms[0]}-${terms[1]} months`;
  return `${terms[0] / 12}-${terms[1] / 12} years`;
};
